import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Card from 'antd/lib/card'
import { setCurrentBuilding } from '../lib/setCurrentBuilding'
import loginBackground from '../assets/images/login.png'
import Divider from './Divider'

const styles = {
    container: {
        position: 'absolute',
        top: '20%',
        left: '38%',
    },
    card: {
        borderRadius: 20,
        width: 450,
        overflow: 'auto',
        opacity: 0.85,
        boxShadow: '0 8px 40px -14px rgba(0,0,0,0.5)',
        maxHeight: 650
    },
    title: {
        marginTop: '0.64em',
        marginBottom: '0.32em',
        textAlign: 'center'
    },
    link: {
        cursor: 'pointer',
        color: '#1BAAF1',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 3
    },
    hover: {
        backgroundColor: '#1baaf173',
        padding: '4px 24px',
        cursor: 'pointer'
    },
    none: {
        backgroundColor: 'white',
        padding: '4px 24px'
    },
}

function sortByBuildingAndTenant(data) {
    return data.sort((a, b) => {
        // Compare by building
        const propertyA = a.property.toLowerCase()
        const propertyB = b.property.toLowerCase()

        const buildingA = a.building.toLowerCase()
        const buildingB = b.building.toLowerCase()

        const tenantA = a.tenant.toLowerCase()
        const tenantB = b.tenant.toLowerCase()

        if (propertyA < propertyB) return -1
        if (propertyA > propertyB) return 1
        if (buildingA < buildingB) return -1
        if (buildingA > buildingB) return 1
        if (tenantA < tenantB) return -1
        if (tenantA > tenantB) return 1
        return 0

    })
}

const BuildingPicker = () => {
    const [hover, setHover] = useState(null)
    const data = useSelector((state) => state.app.occupancies)

    useEffect(() => {
        document.body.style.backgroundImage = `url(${loginBackground})`
        document.body.style.backgroundPosition = 'center'
        document.body.style.backgroundRepeat = 'no-repeat'
        document.body.style.backgroundSize = 'cover'
        document.body.style.backgroundColor = '#bdccd4'
        return () => {
            document.body.style.backgroundImage = null
            document.body.style.backgroundPosition = null
            document.body.style.backgroundRepeat = null
            document.body.style.backgroundSize = null
            document.body.style.backgroundColor = null
        }
    })

    const generateName = (item) => {
        let name = ''

        if (item.property !== item.building) {
            name = `${item.property}: ${item.building}`
        } else {
            name = item.building
        }

        return (
            <>
                <span style={{ fontSize: 15, fontWeight: 600, color: 'black' }}>{name}</span>
                <span style={{ color: '#606060' }}>{item.tenant}</span>
            </>
        )
    }

    const handleBuildingSelection = (item) => {
        // Add a flag to indicate this change comes from building selection
        const buildingData = {
            ...item,
            __fromBuildingSelector: true
        };
        setCurrentBuilding(buildingData);
    };

    return (
        <div style={styles.container}>
            <Card bodyStyle={{ padding: 0 }} bordered={false} style={styles.card}>
                <div style={styles.title}>
                    SELECT FROM THE OPTIONS BELOW
                </div>
                <div style={{ paddingBottom: 8, textAlign: 'center' }}>
                    {sortByBuildingAndTenant(data).map((item, index) => (
                        <div
                            onMouseEnter={() => setHover(index)}
                            onMouseLeave={() => setHover(null)}
                            key={item.sk}
                            style={hover === index ? styles.hover : styles.none}
                            onClick={() => handleBuildingSelection(item)}
                        >
                            <div style={styles.content}>
                                {generateName(item)}
                            </div>
                            {index !== data.length - 1 && <Divider />}

                        </div>
                    ))}
                </div>
            </Card>
        </div>
    )
}

export default BuildingPicker
